/** Hue 0–120 for score-based accent (green → yellow → red). */
export function getScoreHue(score) {
  if (typeof score !== 'number') return null;
  if (score <= 1) {
    if (score <= 0.9) return (score / 0.9) * 60;
    return 120;
  }
  if (score > 1 && score < 8) return ((score - 1) / 7) * 60;
  if (score >= 8 && score < 13) return 60 + ((score - 8) / 5) * 60;
  return 120;
}

function getScoreGradientLight(score) {
  const hue = getScoreHue(score);
  if (hue == null) return 'linear-gradient(135deg, #d3d3d3, #f0f0f0)';
  return `linear-gradient(135deg, hsl(${hue}, 100%, 50%), hsl(${hue}, 100%, 75%))`;
}

/** Accent color for borders / highlights. */
export function getScoreAccentColor(score, darkMode) {
  const hue = getScoreHue(score);
  if (hue == null) return darkMode ? 'var(--theme-border)' : '#d3d3d3';
  if (darkMode) return `hsl(${hue}, 38%, 42%)`;
  return `hsl(${hue}, 85%, 52%)`;
}

/**
 * Outer wrapper for score-colored result cards.
 * Light: gradient ring via padding trick.
 * Dark: single surface + muted score border (no blue ring around gray card).
 */
export function getScoreCardWrapperStyle(score, darkMode, extra = {}) {
  if (darkMode) {
    return {
      position: 'relative',
      borderRadius: 8,
      border: `2px solid ${getScoreAccentColor(score, true)}`,
      background: 'var(--theme-surface)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
      transition: 'border-color 0.5s ease',
      ...extra,
    };
  }
  return {
    position: 'relative',
    background: getScoreGradientLight(score),
    padding: 2,
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    transition: 'background 0.5s ease',
    ...extra,
  };
}

/** Inner card body — transparent in dark mode (wrapper already has surface). */
export function getScoreCardInnerStyle(darkMode, extra = {}) {
  return {
    background: darkMode ? 'transparent' : 'var(--theme-surface)',
    ...extra,
  };
}
